import { Box, Checkbox, FormControlLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "store/types";

interface StateProps {
  radio1: boolean;
}

const RadioToggleSingle = ({
  item1,
  getRadioValues,
  singleToggle,
  fromPromoCalendar,
}: {
  item1: string;
  item2?: string;
  getRadioValues: (state: StateProps) => void;
  singleToggle?: boolean;
  fromPromoCalendar?: boolean;
}) => {
  const { colors } = useSelector((state: AppState) => state.summaryChart);

  const [state, setState] = useState<StateProps>({
    radio1: true,
  });

  const promoTypeList = useSelector(
    (state: AppState) => state.promotionCalendar.promoTypeList
  );

  const isPromoTypeListFullyChecked = () => {
    let result = true;
    promoTypeList.forEach((promoTypeItem: any) => {
      if (!promoTypeItem.checked) {
        result = false;
        return result;
      }
    });
    return result;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === "radio1") {
      setState({
        ...state,
        radio1: !state.radio1,
      });
    }
  };

  useEffect(() => {
    getRadioValues(state);
  }, [state.radio1]);

  useEffect(() => {
    setState({ ...state, radio1: colors });
  }, [colors]);

  return (
    <Box sx={{ display: "flex", margin: "0 8px" }}>
      <Box
        sx={{
          background: fromPromoCalendar
            ? "#FFFFFF"
            : state.radio1
            ? "linear-gradient(90deg, #044E82 0%, #2B94DC 100%)"
            : "#E0E0E0",
          borderRadius: "6px",
          border: "1px solid #D0D5DD",
        }}
      >
        <FormControlLabel
          sx={{
            color: fromPromoCalendar
              ? "#424242"
              : state.radio1
              ? "white"
              : "#757575",
            width: "max-content",
            marginLeft: 0,
          }}
          control={
            <Checkbox
              size="small"
              name={"radio1"}
              checked={
                fromPromoCalendar
                  ? isPromoTypeListFullyChecked()
                    ? true
                    : false
                  : state.radio1
              }
              indeterminate={
                fromPromoCalendar && !isPromoTypeListFullyChecked()
              }
              sx={{
                fontFamily: "Lato",
                fontSize: "16px",
                fontWeight: "400",
                color: state.radio1 ? "white" : "#757575",

                "&.Mui-checked": {
                  color: fromPromoCalendar ? "#0D47A1" : "white",
                },
              }}
              onChange={handleChange}
            />
          }
          label={item1}
        />
      </Box>
    </Box>
  );
};

export default RadioToggleSingle;
